import script from "./ManagedAccountOnboarding.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagedAccountOnboarding.vue?vue&type=script&setup=true&lang=js"

import "./ManagedAccountOnboarding.vue?vue&type=style&index=0&id=2e0a4f95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e0a4f95"]])

export default __exports__